/* eslint-disable no-untranslated-string/no-untranslated-string */
import { actionsFactory, props } from '@ngneat/effects';

const connectCalendarActions = actionsFactory('connectCalendar');

export const connectCalendar = connectCalendarActions.create(
  'Connect Calendar',
  props<{ newUser: boolean }>(),
);

export const connectCalendarFinished = connectCalendarActions.create('Connect Calendar Finished');
